import styled from 'styled-components'

export const Title = styled.h2`
  font-size: 24px;
  text-align: center;
  margin-top: 20px;
`
